import { createContext, useState, useEffect, useContext, useRef } from "react";
import { io } from "socket.io-client";
import { useAuthContext } from "./AuthContext";

const SocketContext = createContext();

export const useSocketContext = () => {
  return useContext(SocketContext);
};

export const SocketContextProvider = ({ children }) => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [notification, setNotification] = useState("");
  const { authUser } = useAuthContext();

  const myId = localStorage.getItem("myId");
  const socketRef = useRef(null); // Store socket reference

  useEffect(() => {
    if (myId && !socketRef.current) {
      // Initialize socket only if not already initialized
      socketRef.current = io("https://saptavidhi-harsh.onrender.com", {
        query: { userId: myId },
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 3000,
      });

      const socket = socketRef.current;

      socket.on("connect", () => {
        //console.log("✅ Connected to socket server");
      });

      socket.on("disconnect", () => {
        //console.log("❌ Disconnected from socket server");
      });

      socket.on("connect_error", (error) => {
        //console.log("⚠️ Connection Error:", error);
      });

      socket.on("getOnlineUsers", (users) => {
        // Filter out the current user's ID
        const filteredUsers = users.filter((user) => user !== myId);
        setOnlineUsers(filteredUsers);
      });

      socket.on("newNotification", (notification) => {
        //console.log("🔔 New Notification:", notification);
        setNotification(notification);
      });
    }

    // Cleanup function: Disconnect socket when component unmounts
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [myId]);

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        onlineUsers,
        setOnlineUsers,
        notification,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};
